<template>
    <div class="permissionSetting">
        <div class="l">
            <el-table
                ref="singleTable"
                :data="roleList"
                highlight-current-row
                @current-change="queryRoleResource"
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <!-- <el-table-column
                prop="name"
                label="角色列表"
                align="center"
                > -->
                    <el-table-column
                    prop="name"
                    label="角色"
                    align="center"
                    >
                    </el-table-column>
                   
                <!-- </el-table-column> -->
            </el-table>
            <el-pagination
                @current-change="handleCurrentChange"
                background
                layout="prev, pager, next"
                :total="totalCount"
                :current-page="conditionData.page"
                :page-size="conditionData.pageSize">
            </el-pagination>
        </div>
        <div class="r">
            <div class="module">
                <div class="title">
                    模块
                </div>
                <div class="main">

                    <div :class="moduleIndex==index?'item item-this':'item'" @click="selectModule(index,item)" v-for="(item,index) in sectionList" :key="index">
                        <el-checkbox v-model="item.isCheck" label=""></el-checkbox>
                        {{item.name}}
                    </div>
                </div>
                <!-- <div class="btn">
                    <el-button type="primary" size="medium">新增模块</el-button>
                </div> -->
            </div>
            <div class="permission">
                <div class="title">
                    页面
                </div>
                <div class="main">
                    <div class="item" v-for="(item,index) in resourceList" :key="index">
                        <div class="p-title">
                            <el-checkbox v-model="item.isCheck" :label="item.name"></el-checkbox>
                        </div>
                        <div class="con" >
                            <el-checkbox v-model="itemc.isCheck" :label="itemc.name" v-for="(itemc,indexc) in item.children" :key="indexc" border></el-checkbox>
                        </div>
                    </div>
                    <div class="btns">
                        <!-- <el-button type="primary">全部选中</el-button>
                        <el-button type="warning">全部取消</el-button> -->
                        <el-button type="primary" @click="saveResource">保存</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../../../api/base'
export default {
    name: 'person',
    data () {
        return {
            moduleIndex:0,
            checked:false,
            conditionData:{
                page:1,
                pageSize:10,
            },
            totalCount:0,
            roleList:[],
            sectionList:[],
            userId:'',
            resourceList:[],
        }
    },
    created(){
        

    },
    mounted(){
        this.getRoleList();
    },
    methods:{
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #222222;font-weight: bold;font-size: 15px;'
            }
        },
        // 添加资源
        async saveResource(){
            let permissions = [];
            console.log(this.sectionList);
            for(let i in this.sectionList){
                if(this.sectionList[i].isCheck){
                    permissions.push({
                        uroleId:this.userId,
                        resourceId:this.sectionList[i].id,
                    })
                }
                for(let j in this.sectionList[i].children){
                    if(this.sectionList[i].children[j].isCheck){
                        permissions.push({
                            uroleId:this.userId,
                            resourceId:this.sectionList[i].children[j].id,
                        })
                    }
                    for(let k in this.sectionList[i].children[j].children){
                        if(this.sectionList[i].children[j].children[k].isCheck){
                            permissions.push({
                                uroleId:this.userId,
                                resourceId:this.sectionList[i].children[j].children[k].id,
                            })
                        }
                    }
                }
            }
            let res  = await api.updatePermission({permissions:permissions});
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '设置成功!'
                });
            }
        },
        // 查询页面资源
        async selectModule(index,row){
            this.moduleIndex = index;
            this.resourceList = row.children;
        },
        // 角色列表
        async getRoleList(){
            let res  = await api.roleList(this.conditionData);
            this.roleList = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        // 根据角色id查询资源
        async queryRoleResource(event){
            console.log(event);
            let res = await api.queryRoleResource(
                event.id
            );
            this.userId = event.id;
            this.sectionList = res.data.data
            this.resourceList = this.sectionList[0].children
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.getRoleList();
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .permissionSetting{
        display: flex;
        .l{
            width: 350px;
            background-color: #ffffff;
            .el-pagination{
                padding: 10px 0;
                margin-left: 5px;
            }
            /deep/.el-table__body tr.current-row>td{
                background-color: #e6f7ff;
                color: #1890ff;
            }
        }
        .r{
            flex: auto;
            margin-left: 20px;
            background-color: #ffffff;
            display: flex;
            .title{
                background-color: #F2F2F2;
                color: #222222;
                font-weight: bold;
                font-size: 15px;
                height: 48px;
                line-height: 48px;
                padding-left: 20px;
                text-align: center;
            }
            .module{
                width: 200px;
                .main{
                    .item{
                        font-size: 14px;
                        height: 42px;
                        line-height: 42px;
                        text-align: center;
                        border-bottom: 1px solid #F2F2F2;
                        cursor: pointer;
                    }
                    .item:hover{
                        color: #1890ff;
                    }
                    .item-this{
                        background-color: #e6f7ff;
                        color: #1890ff;

                    }
                    
                }
                .btn{
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    padding: 10px 0;
                }
            }
            .permission{
                display: flex;
                flex-direction: column;
                flex: auto;
                .title{
                    // text-align: left;
                    // padding-left: 20px;
                }
                .main{
                    flex: auto;
                    background-color: rgb(245, 245, 245);
                    .item{
                        padding-bottom: 15px;
                        border-top: 1px solid #e8e8e8;
                        .p-title{
                            margin-left: 20px;
                            margin-top: 15px;
                            font-size: 14px;
                            // font-weight: bold;
                        }
                        .con{
                            display: flex;
                            flex-wrap: wrap;
                            .el-checkbox{
                                background-color: #ffffff;
                                margin-left: 15px;
                                margin-right: 0px;
                                margin-top: 15px;
                            }
                        }
                        
                    }
                    .btns{
                        display: flex;
                        justify-content: center;
                        padding: 15px 0;
                        margin-left: 20px;
                        border-top: 1px solid #e8e8e8;
                        .el-button{
                            margin: 0 10px;
                        }
                    }
                }
            }
        }
    }
    
</style>
